import { useMemo } from 'react';

import {
	isTripClosedByBookingType,
	isTripCompletelyClosedFromBookings,
	TicketsTabTrip,
} from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';
import { AvailabilityStatus } from '../Types/AvailabilityStatus';
import { useAvailability } from './useAvailability';

export const useAvailabilityStatus = (
	trip: TicketsTabTrip,
	ticketType: TabSelected = 'passenger',
): AvailabilityStatus => {
	const availability = useAvailability(trip);
	const availabilityPercent = useMemo(() => {
		if (ticketType === 'vehicle') {
			return (availability.vehicle / availability.totalVehicle) * 100;
		}
		return (availability.passenger / trip.passengerSpacesTotal) * 100;
	}, [
		ticketType,
		availability.vehicle,
		availability.totalVehicle,
		availability.passenger,
		trip.passengerSpacesTotal,
	]);

	if (trip.departed) {
		return 'departed';
	}

	// One question, asked once: closed for THIS booking type. Being shut to every type always
	// implies being shut to this one, except where a vehicle needs no passenger — and there a
	// vehicle booking is genuinely still possible, so it must not read as closed.
	const isCompletelyClosed = isTripClosedByBookingType(trip, ticketType);
	if (isCompletelyClosed) {
		return 'closed';
	}

	// if (trip.isHidden) {
	// 	return 'hidden';
	// }

	if (availabilityPercent === 0) {
		return 'no-availability';
	}

	if (ticketType === 'passenger' && availability.passenger === 0) {
		return 'no-availability';
	}

	if (ticketType === 'vehicle' && availability.vehicle < 1) {
		return 'no-availability';
	}

	if (availabilityPercent >= 50) {
		return 'high-availability';
	}

	return 'low-availability';
};
